<div id="main"
     fxLayout="column"
     fxLayoutAlign="start center">

  <div id="title"
       class="upload-title">
    Upload files below
  </div>

  <uppy-dashboard [uppy]="uppy"
                  [props]="uppyDashboardOptions"></uppy-dashboard>

  <div class="footer">
    <mat-form-field appearance="outline">
      <mat-label>Category</mat-label>
      <mat-select [(ngModel)]="selectedCategory"
                  (selectionChange)="onCategoryChange()">
        <mat-option *ngFor="let category of categories"
                    [value]="category.value">{{category.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <button class="footer__button"
            mat-button
            (click)="cancel()">CANCEL</button>
    <button class="footer__button"
            mat-flat-button
            color="primary"
            [disabled]="!valid"
            (click)="submit()">SUBMIT</button>
  </div>
</div>
